import { useState } from "react";
import { Button } from "@/components/ui/button";
import { FileSpreadsheet, FileText } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

// Reusable Excel + PDF export buttons.
// `path` is the export endpoint without format, e.g. "/export/contacts"
export default function ExportButtons({ path, params = {}, label = "", size = "sm", testidPrefix = "export" }) {
  const [busy, setBusy] = useState("");

  const run = async (format) => {
    setBusy(format);
    try {
      const qs = new URLSearchParams({ ...params, format }).toString();
      await api.downloadExport(`${path}?${qs}`, `finakis.${format}`);
      toast.success(`${label || "Liste"} ${format.toUpperCase()} olarak indirildi`);
    } catch {
      toast.error("Dışa aktarma başarısız");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Button data-testid={`${testidPrefix}-xlsx`} size={size} variant="outline" disabled={busy === "xlsx"} onClick={() => run("xlsx")} className="gap-1.5">
        <FileSpreadsheet className="h-4 w-4 text-emerald-400" /> Excel
      </Button>
      <Button data-testid={`${testidPrefix}-pdf`} size={size} variant="outline" disabled={busy === "pdf"} onClick={() => run("pdf")} className="gap-1.5">
        <FileText className="h-4 w-4 text-rose-400" /> PDF
      </Button>
    </div>
  );
}
